import axios from '@/axios.js'

export default ({
  isRegistered: false,
  namespaced: true,
  state: {
    productos: []
  },
  actions: {
    getProducto (context, productoId) {
      return new Promise((resolve, reject) => {
        axios.get(`/api/val_productos/${productoId}`)
          .then((response) => {
            resolve(response)
          })
          .catch((error) => { reject(error) })
      })
    },
    getProductos ({ commit }) {
      return new Promise((resolve, reject) => {
        axios.get('/api/val_productos')
          .then((response) => {
            commit('setProductosMutation', response.data['hydra:member'])
            resolve(response)
          })
          .catch((error) => { reject(error) })
      })
    },
    getProductosActivos ({ commit }) {
      return new Promise((resolve, reject) => {
        axios.get('/api/val_productos?activo=1')
          .then((response) => {
            commit('setProductosActivosMutation', response.data['hydra:member'])
            resolve(response)
          })
          .catch((error) => { reject(error) })
      })
    },
    addProducto ({ commit }, producto) {
      return new Promise((resolve, reject) => {
        axios.post('/api/val_productos', producto)
          .then((response) => {
            commit('addProductoMutation', response)
            resolve(response)
          })
          .catch((error) => { 
            reject(error) 
          })
      })
    },
    deleteProducto ({ commit }, id) {
      return new Promise((resolve, reject) => {
        axios.delete(`/api/val_productos/${id}`)
          .then((response) => {
            commit('deleteProductoMutation', id)
            resolve(response)
          })
          .catch((error) => { reject(error) })
      })
    },
    updateProducto ({ commit }, producto) {
      return new Promise((resolve, reject) => {
        axios.patch(`/api/val_productos/${producto.id}`, producto, { headers: {'Content-Type': 'application/merge-patch+json'} })
          .then((response) => {
            commit('updateProductoMutation', response.data)
            resolve(response)
          })
          .catch((error) => { reject(error) })
      })
    },
    importarValProductos (context, formData) {
      return new Promise((resolve, reject) => {
        axios.post('/api/importar_val_productos', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error) 
          })
      })
    },
    emptyProductos ({ commit }) {
      commit('emptyProductosMutation')
    }
  },
  mutations: {
    setProductosMutation (state, producto) {
      state.productos = producto
    },
    setProductosActivosMutation (state, producto) {
      state.tiposProductosActivos = producto
    },
    addProductoMutation (state, producto) {
      state.productos.push(producto)
    },
    updateProductoMutation (state, producto) {
      const idx = state.productos.findIndex((u) => u.id === producto.id) // Buscamos o índice do elemento no array do state
      state.productos.splice(idx, 1, producto)
    },
    deleteProductoMutation (state, id) {
      const idx = state.productos.findIndex((u) => u.id === id) // Buscamos o índice do elemento no array do state
      state.productos.splice(idx, 1)
    },
    emptyProductosMutation (state) {
      // Vaciamos o store
      state.productos = []
    }
  },
  modules: {}
})